export default {
  itemToolbar: {
    move: "Move",
    top: "Move top",
    up: "Move up",
    down: "Move down",
    bottom: "Move bottom",
    remove: "Remove",
  },
};
